<template>
  <div>
    <div class="service-container" style="margin-top: 8px;">
      <img class="service-main-img" src="@/assets/img/多肽服务.png" alt="多肽服务主图" loading="eager" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Service',
  data() {
    return {
      galleryImgs: [
       
      ]
    }
  }
}
</script>

<style scoped>
.service-container {
  padding: 0;
  text-align: center;
  margin-top: 8px;
}
.service-main-img {
  width: 100vw;
  height: 280px;
  object-fit: cover;
  display: block;
  margin: 0 auto 0 auto;
  border-radius: 0;
  box-shadow: none;
  background: #fff;
}
.service-gallery {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
  margin-top: 20px;
}
.service-img-item {
  width: 180px;
  text-align: center;
}
.service-img-item img {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.img-caption {
  margin-top: 8px;
  color: #666;
  font-size: 14px;
}
</style>

<style>
@media (max-width: 768px) {
  .service-main-img {
    height: 120px;
    min-height: 80px;
    max-height: 180px;
  }
  .service-container {
    margin-top: 4px;
    padding: 0;
  }
}
</style>
